<template>
  <div id="serviceList">
    <!-- 横幅 -->
    <div class="banner">
      <img src="../../assets/images/serviceList/banner.png" alt="" />
    </div>
    <!-- 测试长安识别 -->
    <div class="outer" id="captureId" v-if="false">
      <div class="content df-center qr_code_box" v-if="firstFlag">
        <img
          src="../../assets/images/i-wx-code.jpg"
          alt=""
          style="width: 250px; height: 250px"
        />
      </div>
      <div class="content df-center qr_code_box other_qr" v-if="!firstFlag">
        <!-- <van-image
          width="100%"
          height="100%"
          :src="imgUrl"
          style="width: 450px; height: 250px"
        ></van-image> -->
        <img :src="imgUrl" alt="" style="width: 450px;" />
      </div>
      111
    </div>
    <!-- tab栏 -->
    <van-tabs v-model="tabIndex" color="#26B4FF" title-active-color="#26B4FF">
      <div class="div" style="border-bottom: 1px solid #eee"></div>
      <van-tab title="院内感控">
        <!--服务包轮播图 -->
        <div class="swipe_wrap">
          <div class="swipe_center df-item-center">
            <!-- :autoplay="3000"  -->
            <div @click="preSwipe">
              <img
                src="../../assets/images/serviceList/i-swipe-left.png"
                alt=""
              />
            </div>
            <van-swipe
              class="my-swipe"
              :show-indicators="false"
              @change="swipeChange"
              ref="hospitalSwipe"
            >
              <template v-if="hospitalPackage.length > 0">
                <van-swipe-item
                  class="swipe_item"
                  v-for="(item, index) in hospitalPackage"
                  :key="index"
                >
                  <div class="header">
                    <div class="package_title ellipsis-1">
                      {{ item.packageTitle }}
                    </div>
                    <div class="package_sub_title ellipsis-1">
                      {{ item.packageSubTitle }}
                    </div>
                    <div class="package_desc ellipsis-1">
                      {{ item.packageDesc }}
                    </div>
                  </div>
                  <div class="body">
                    <!-- <template v-if="item.price"> -->
                    <div class="package_price df-center">
                      {{ handlePrice(item) }}
                      <span>{{ handlePriceDesc(item) }}</span>
                    </div>
                    <div
                      class="buy_btn df-center"
                      @click="goApplyUse('hospital', item)"
                    >
                      立即购买
                    </div>
                    <!-- </template> -->
                  </div>
                </van-swipe-item>
              </template>
            </van-swipe>
            <div @click="nextSwipe">
              <img
                src="../../assets/images/serviceList/i-swipe-right.png"
                alt=""
              />
            </div>
          </div>
          <div class="swipe_indicator df-center">
            <div
              class="swipe_indicator_item"
              :class="{ active: index === hospitalPackageIndex }"
              v-for="(item, index) in hospitalPackage"
              :key="index"
            ></div>
          </div>
          <!-- <img src="" alt=""> -->
        </div>
        <!-- 服务包详情 -->
        <div class="package_detail">
          <div
            ref="hospitalStickContainer"
            class="package_stick_panel"
            :class="{ package_stick_panel_show: hospitalStickContainerShow }"
          >
            <van-sticky
              :container="stickContainer"
              @scroll="hospitalPackageScroll"
            >
              <div class="stick_swrap">
                <div @click="preSwipe">
                  <img
                    src="../../assets/images/serviceList/i-swipe-left.png"
                    alt=""
                  />
                </div>
                <div>
                  <div class="package_title ellipsis-1">
                    {{
                      hospitalPackage[hospitalPackageIndex] &&
                      hospitalPackage[hospitalPackageIndex].packageTitle
                    }}
                  </div>
                  <div class="dot_list df-center">
                    <div
                      class="dot"
                      v-for="(item, index) in hospitalPackage"
                      :key="index"
                      :class="{ active: index === hospitalPackageIndex }"
                    ></div>
                  </div>
                </div>
                <div @click="nextSwipe">
                  <img
                    src="../../assets/images/serviceList/i-swipe-right.png"
                    alt=""
                  />
                </div>
              </div>
            </van-sticky>
          </div>
          <div
            class="detail_package_name"
            :class="{ detail_package_name_hide: hospitalStickContainerShow }"
          >
            {{
              hospitalPackage[hospitalPackageIndex] &&
              hospitalPackage[hospitalPackageIndex].packageTitle
            }}
          </div>
          <div class="detail_package_content">
            <div
              class="package_table"
              :class="{ package_table_more: hospitalTableShowMore }"
            >
              <!-- 医院服务包等级 -->
              <div
                class="table_item"
                v-for="(item, index) in hospitalPackageList[
                  hospitalPackageIndex
                ]"
                :key="index"
              >
                <!-- 一级 -->
                <div class="tr tr_1">
                  <div class="td">{{ item.title }}</div>
                </div>
                <!-- 二级 -->
                <template v-if="item.children">
                  <div v-for="(itme2, index2) in item.children" :key="index2">
                    <!-- 当有二级时, 显示二级和三级 -->
                    <div
                      class="table_item_2"
                      v-if="
                        item.children.length > 0 &&
                        item.children[index2].level === 2
                      "
                    >
                      <div class="tr tr_2">
                        <div class="td">{{ itme2.title }}</div>
                      </div>
                      <template v-if="itme2.children.length > 0">
                        <div
                          class="tr"
                          v-for="(itme3, index3) in itme2.children"
                          :key="index3"
                        >
                          <div class="td td_left">{{ itme3.title }}</div>
                          <div class="td td_right df-center">
                            <span v-if="itme3.descType === 2">{{
                              itme3.desc
                            }}</span>
                            <img
                              src="../../assets/images/serviceList/i-right.png"
                              alt=""
                              class="i_right"
                              v-if="itme3.descType === 1"
                            />
                            <img
                              src="../../assets/images/serviceList/i-error.png"
                              alt=""
                              class="i_error"
                              v-if="itme3.descType === 0"
                            />
                          </div>
                        </div>
                      </template>
                    </div>
                    <!-- 当没有二级时, 显示三级 -->
                    <div
                      class="table_item_3"
                      v-if="
                        item.children.length > 0 &&
                        item.children[index2].level === 3
                      "
                    >
                      <div class="tr">
                        <div class="td td_left">{{ itme2.title }}</div>
                        <div class="td td_right df-center">
                          <span v-if="itme2.descType === 2">{{
                            itme2.desc
                          }}</span>
                          <img
                            src="../../assets/images/serviceList/i-right.png"
                            alt=""
                            class="i_right"
                            v-if="itme2.descType === 1"
                          />
                          <img
                            src="../../assets/images/serviceList/i-error.png"
                            alt=""
                            class="i_error"
                            v-if="itme2.descType === 0"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
              <!-- <div
                  class="table_item_2"
                  v-if="
                    item.children.length > 0 && item.children[0].level === 2
                  "
                >
                  <div v-for="(itme2, index2) in item.children" :key="index2">
                    <div class="tr tr_2">
                      <div class="td">{{ itme2.title }}</div>
                    </div>
                    <template v-if="itme2.children.length > 0">
                      <div
                        class="tr"
                        v-for="(itme3, index3) in itme2.children"
                        :key="index3"
                      >
                        <div class="td td_left">{{ itme3.title }}</div>
                        <div class="td td_right df-center">
                          <span v-if="itme3.descType === 2">{{
                            itme3.desc
                          }}</span>
                          <img
                            src="../../assets/images/serviceList/i-right.png"
                            alt=""
                            class="i_right"
                            v-if="itme3.descType === 1"
                          />
                          <img
                            src="../../assets/images/serviceList/i-error.png"
                            alt=""
                            class="i_error"
                            v-if="itme3.descType === 0"
                          />
                        </div>
                      </div>
                    </template>
                  </div>
                </div> -->
              <!-- 当没有二级时, 显示三级 -->
              <!-- <div
                  class="table_item_3"
                  v-if="
                    item.children.length > 0 && item.children[0].level === 3
                  "
                >
                  <div
                    class="tr"
                    v-for="(itme3, index3) in item.children"
                    :key="index3"
                  >
                    <div class="td td_left">{{ itme3.title }}</div>
                    <div class="td td_right df-center">
                      <span v-if="itme3.descType === 2">{{ itme3.desc }}</span>
                      <img
                        src="../../assets/images/serviceList/i-right.png"
                        alt=""
                        class="i_right"
                        v-if="itme3.descType === 1"
                      />
                      <img
                        src="../../assets/images/serviceList/i-error.png"
                        alt=""
                        class="i_error"
                        v-if="itme3.descType === 0"
                      />
                    </div>
                  </div>
                </div> -->
              <!-- </div> -->
              <!-- 底部的蒙版 -->
              <div class="package_mask"></div>
            </div>
          </div>
          <div
            class="detail_package_footer df-center"
            @click="hospitalTableShowMore = !hospitalTableShowMore"
          >
            <span v-if="!hospitalTableShowMore">展开查看更多</span>
            <span v-else>收起</span>
            <img
              src="../../assets/images/serviceList/i-down.png"
              alt=""
              v-if="!hospitalTableShowMore"
            />
            <img
              src="../../assets/images/serviceList/i-top.png"
              alt=""
              v-else
            />
          </div>
        </div>
        <!-- 申请购买流程及所需资料 -->
        <apply-info
          :downObj="hospitalPackage[hospitalPackageIndex]"
          :isHospital="true"
        />
        <!-- 购买后服务清单 -->
        <buy-service-list />
      </van-tab>
      <van-tab title="区域感控">
        <!--服务包轮播图 -->
        <div class="swipe_wrap">
          <div class="swipe_center df-item-center">
            <!-- :autoplay="3000"  -->
            <div @click="preSwipe">
              <img
                src="../../assets/images/serviceList/i-swipe-left.png"
                alt=""
              />
            </div>
            <van-swipe
              class="my-swipe"
              :show-indicators="false"
              @change="swipeChange"
              ref="areaSwipe"
            >
              <van-swipe-item
                class="swipe_item"
                v-for="(item, index) in areaPackage"
                :key="index"
              >
                <div class="header">
                  <div class="package_title ellipsis-1">
                    {{ areaPackage[areaPackageIndex] && item.packageTitle }}
                  </div>
                  <div class="package_sub_title ellipsis-1">
                    {{ item.packageSubTitle }}
                  </div>
                  <div class="package_desc ellipsis-1">
                    {{ item.packageDesc }}
                  </div>
                </div>
                <div class="body">
                  <!-- <template v-if="item.price"> -->
                  <div class="package_price df-center">
                    {{ handlePrice(item) }}
                    <span>{{ handlePriceDesc(item) }}</span>
                  </div>
                  <div
                    class="buy_btn df-center"
                    @click="goApplyUse('area', item)"
                  >
                    立即购买
                  </div>
                  <!-- </template> -->
                </div>
              </van-swipe-item>
            </van-swipe>
            <div @click="nextSwipe">
              <img
                src="../../assets/images/serviceList/i-swipe-right.png"
                alt=""
              />
            </div>
          </div>
          <div class="swipe_indicator df-center">
            <div
              class="swipe_indicator_item"
              :class="{ active: index === areaPackageIndex }"
              v-for="(item, index) in areaPackage"
              :key="index"
            ></div>
          </div>
          <!-- <img src="" alt=""> -->
        </div>
        <!-- 服务包详情 -->
        <div class="package_detail">
          <div
            ref="hospitalStickContainer"
            class="package_stick_panel"
            :class="{ package_stick_panel_show: areaStickContainerShow }"
          >
            <van-sticky
              :container="areastickContainer"
              @scroll="hospitalPackageScroll"
            >
              <div class="stick_swrap">
                <div @click="preSwipe">
                  <img
                    src="../../assets/images/serviceList/i-swipe-left.png"
                    alt=""
                  />
                </div>
                <div>
                  <div class="package_title ellipsis-1">
                    {{
                      areaPackage[areaPackageIndex] &&
                      areaPackage[areaPackageIndex].packageTitle
                    }}
                  </div>
                  <div class="dot_list df-center">
                    <div
                      class="dot"
                      v-for="(item, index) in areaPackage"
                      :key="index"
                      :class="{ active: index === areaPackageIndex }"
                    ></div>
                  </div>
                </div>
                <div @click="nextSwipe">
                  <img
                    src="../../assets/images/serviceList/i-swipe-right.png"
                    alt=""
                  />
                </div>
              </div>
            </van-sticky>
          </div>
          <div
            class="detail_package_name"
            :class="{ detail_package_name_hide: areaStickContainerShow }"
          >
            {{
              areaPackage[areaPackageIndex] &&
              areaPackage[areaPackageIndex].packageTitle
            }}
          </div>
          <div class="detail_package_content">
            <div
              class="package_table"
              :class="{ package_table_more: areaTableShowMore }"
            >
              <!-- 医院服务包等级 -->
              <div
                class="table_item"
                v-for="(item, index) in areaPackageList[areaPackageIndex]"
                :key="index"
              >
                <!-- 一级 -->
                <div class="tr tr_1">
                  <div class="td">{{ item.title }}</div>
                </div>
                <!-- 二级 -->
                <template v-if="item.children">
                  <div v-for="(itme2, index2) in item.children" :key="index2">
                    <!-- 当有二级时, 显示二级和三级 -->
                    <div
                      class="table_item_2"
                      v-if="
                        item.children.length > 0 &&
                        item.children[index2].level === 2
                      "
                    >
                      <div class="tr tr_2">
                        <div class="td">{{ itme2.title }}</div>
                      </div>
                      <template v-if="itme2.children.length > 0">
                        <div
                          class="tr"
                          v-for="(itme3, index3) in itme2.children"
                          :key="index3"
                        >
                          <div class="td td_left">{{ itme3.title }}</div>
                          <div class="td td_right df-center">
                            <span v-if="itme3.descType === 2">{{
                              itme3.desc
                            }}</span>
                            <img
                              src="../../assets/images/serviceList/i-right.png"
                              alt=""
                              class="i_right"
                              v-if="itme3.descType === 1"
                            />
                            <img
                              src="../../assets/images/serviceList/i-error.png"
                              alt=""
                              class="i_error"
                              v-if="itme3.descType === 0"
                            />
                          </div>
                        </div>
                      </template>
                    </div>
                    <!-- 当没有二级时, 显示三级 -->
                    <div
                      class="table_item_3"
                      v-if="
                        item.children.length > 0 &&
                        item.children[index2].level === 3
                      "
                    >
                      <div class="tr">
                        <div class="td td_left">{{ itme2.title }}</div>
                        <div class="td td_right df-center">
                          <span v-if="itme2.descType === 2">{{
                            itme2.desc
                          }}</span>
                          <img
                            src="../../assets/images/serviceList/i-right.png"
                            alt=""
                            class="i_right"
                            v-if="itme2.descType === 1"
                          />
                          <img
                            src="../../assets/images/serviceList/i-error.png"
                            alt=""
                            class="i_error"
                            v-if="itme2.descType === 0"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- 当有二级时, 显示二级和三级 -->
                <!-- <div
                  class="table_item_2"
                  v-if="
                    item.children.length > 0 && item.children[0].level === 2
                  "
                >
                  <div v-for="(itme2, index2) in item.children" :key="index2">
                    <div class="tr tr_2">
                      <div class="td">{{ itme2.title }}</div>
                    </div>
                    <template v-if="itme2.children.length > 0">
                      <div
                        class="tr"
                        v-for="(itme3, index3) in itme2.children"
                        :key="index3"
                      >
                        <div class="td td_left">{{ itme3.title }}</div>
                        <div class="td td_right df-center">
                          <span v-if="itme3.descType === 2">{{
                            itme3.desc
                          }}</span>
                          <img
                            src="../../assets/images/serviceList/i-right.png"
                            alt=""
                            class="i_right"
                            v-if="itme3.descType === 1"
                          />
                          <img
                            src="../../assets/images/serviceList/i-error.png"
                            alt=""
                            class="i_error"
                            v-if="itme3.descType === 0"
                          />
                        </div>
                      </div>
                    </template>
                  </div>
                </div> -->
                <!-- 当没有二级时, 显示三级 -->
                <!-- <div
                  class="table_item_3"
                  v-if="
                    item.children.length > 0 && item.children[0].level === 3
                  "
                >
                  <div
                    class="tr"
                    v-for="(itme3, index3) in item.children"
                    :key="index3"
                  >
                    <div class="td td_left">{{ itme3.title }}</div>
                    <div class="td td_right df-center">
                      <span v-if="itme3.descType === 2">{{ itme3.desc }}</span>
                      <img
                        src="../../assets/images/serviceList/i-right.png"
                        alt=""
                        class="i_right"
                        v-if="itme3.descType === 1"
                      />
                      <img
                        src="../../assets/images/serviceList/i-error.png"
                        alt=""
                        class="i_error"
                        v-if="itme3.descType === 0"
                      />
                    </div>
                  </div>
                </div> -->
              </div>
              <!-- 底部的蒙版 -->
              <div class="package_mask"></div>
            </div>
          </div>
          <div
            class="detail_package_footer df-center"
            @click="areaTableShowMore = !areaTableShowMore"
          >
            <span v-if="!areaTableShowMore">展开查看更多</span>
            <span v-else>收起</span>
            <img
              src="../../assets/images/serviceList/i-down.png"
              alt=""
              v-if="!areaTableShowMore"
            />
            <img
              src="../../assets/images/serviceList/i-top.png"
              alt=""
              v-else
            />
          </div>
        </div>
        <!-- 申请购买流程及所需资料 -->
        <apply-info
          :downObj="areaPackage[areaPackageIndex]"
          :isHospital="false"
        />
        <!-- 购买后服务清单 -->
        <!-- <buy-service-list /> -->
      </van-tab>
    </van-tabs>
    <!-- 底部占位盒子 -->

    <div class="footer_holder"></div>
    <!-- 底部按钮组 -->
    <promote-footer v-if="isPreview == 2" />
  </div>
</template>

<script>
import applyInfo from "@/components/serviceList/apply-info";
import buyServiceList from "@/components/serviceList/buy-service-list";
import PromoteFooter from "../../components/serviceList/promote-footer.vue";
import html2canvas from "html2canvas";
// import BuyServiceList from '../../components/serviceList/buy-service-list.vue';

export default {
  components: {
    applyInfo,
    buyServiceList,
    PromoteFooter,
  },
  data() {
    return {
      serveId: "",
      tabIndex: 0,
      // 院内感控服务包
      hospitalPackage: [],
      // 院内轮播图服务包索引
      hospitalPackageIndex: 0,
      // 院内服务包列表
      hospitalPackageList: [],
      // 院内服务包显示更多
      hospitalTableShowMore: false,
      // 吸顶容器
      stickContainer: null,
      // 院内吸顶容器z-index:
      hospitalStickContainerShow: false,
      // 区域感控服务包
      areaPackage: [],
      //区域轮播图服务包索引
      areaPackageIndex: 0,
      // 区域服务包列表
      areaPackageList: [],
      // 区域服务包显示更多
      areaTableShowMore: false,
      // 区域吸顶容器
      areastickContainer: null,
      // 区域吸顶容器z-index:
      areaStickContainerShow: false,
      // 底部组件隐藏
      isPreview: 2,
      // canvas
      imgUrl: "",
      // cavas图片替换flag
      firstFlag:true,
    };
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.initImg();
      }, 200);
    });
    this.stickContainer = this.$refs["hospitalStickContainer"];
    this.areastickContainer = this.$refs["areaStickContainer"];
  },
  watch: {
    tabIndex() {
      // if(this.isPreview == '1') {
      //   this.getPackageListAndDetail();
      //   return
      // }
      if (this.tabIndex === 1 && this.areaPackage.length === 0) {
        this.getPackageListAndDetail();
      } else if (this.tabIndex === 0 && this.hospitalPackage.length === 0) {
        this.getPackageListAndDetail();
      }
    },
  },
  created() {
    if (this.$route.query && this.$route.query.isPreview == "1") {
      this.isPreview = 1;
    } else {
      this.isPreview = 2;
    }
    this.tabIndex =
      this.$route.query.packageType == 1
        ? 0
        : this.$route.query.packageType == 2
        ? 1
        : 0; // 获取后台预览带过来的packageType
    this.serveId = this.$route.query.id; // 获取后台预览带过来的服务包id
    this.getPackageListAndDetail();
    // this.getPackageList()
  },
  methods: {
    // 轮播图改变
    swipeChange(e) {
      if (this.tabIndex === 0) {
        this.hospitalPackageIndex = e;
      } else if (this.tabIndex === 1) {
        this.areaPackageIndex = e;
      }
    },
    initImg() {
      // 背景图需要设置给将要截取图片的子级subjectsuccess-body，不然截取的图片背景图显示不出
       html2canvas(document.querySelector("#serviceList")).then((canvas) => {
         let imgUrl = canvas.toDataURL('image/png');
        this.imgUrl = imgUrl
        this.firstFlag = false;
        console.log(this.imgUrl, "图片路径....");
      });
    },
    // 价格处理
    handlePrice(item) {
      let priceType = item.priceSettingType;
      let handleStr = "";
      if (priceType == "1") {
        handleStr = item.price;
      } else if (priceType == "2") {
        handleStr = item.price;
      } else if (priceType == "3") {
        handleStr = item.lowestPrice + "-" + item.highestPrice;
      } else if (priceType == "4") {
        handleStr = "";
      } else if (priceType == "5") {
        handleStr = "";
      }
      return handleStr;
    },
    // 价格描述处理
    handlePriceDesc(item) {
      let priceType = item.priceSettingType;
      let handleStr = "";
      if (priceType == "1") {
        handleStr = item.priceDesc;
      } else if (priceType == "2") {
        handleStr = item.priceDesc;
      } else if (priceType == "3") {
        handleStr = item.priceDesc;
      } else if (priceType == "4") {
        handleStr = "按需核算";
      } else if (priceType == "5") {
        handleStr = "具体价格请电话咨询";
      }
      return handleStr;
    },
    // 获取服务包列表带详情
    getPackageListAndDetail() {
      let params = {
        state: "1",
        page: "1",
        offset: "10",
      };
      params.packageType = this.tabIndex === 0 ? "1" : "2";
      this.$http.getPackageList(params).then((res) => {
        if (res.status === 200 && res.data) {
          // 院内感控
          if (this.tabIndex === 0) {
            // 服务包
            this.hospitalPackage = res.data.map((v) => {
              return {
                id: v.id,
                packageTitle: v.packageName,
                packageSubTitle: v.valueDescribe,
                packageDesc: v.applicableObjects,
                price: v.price,
                priceDesc: v.priceUnitName,
                applyReportFileId: v.applyReportFileId,
                applyReportFileName: v.applyReportFileName,
                signContractFileId: v.signContractFileId,
                signContractFileName: v.signContractFileName,
                priceSettingType: v.priceSettingType,
                lowestPrice: v.lowestPrice,
                highestPrice: v.highestPrice,
              };
            });
            if (this.isPreview == 1) {
              // 后台预览跳转
              this.hospitalPackage.forEach((v, i) => {
                if (this.serveId == v.id) {
                  this.$refs["hospitalSwipe"].swipeTo(i);
                }
              });
            }
            // 服务包详情列表
            let outerArr = [];
            res.data.forEach((v1) => {
              let innerArr = [];
              v1.serviceContents.forEach((v2) => {
                // 一级
                let itemObj = {};
                itemObj.id = v2.id;
                itemObj.title = v2.content;
                itemObj.level = 1;
                itemObj.children = [];
                if (v2.children) {
                  v2.children.forEach((v3) => {
                    // 如果没有children 自己 就是三级
                    if (!v3.children) {
                      let threeObj = {};
                      threeObj.id = v3.id;
                      threeObj.title = v3.content;
                      threeObj.desc = v3.contentValue;
                      threeObj.descType = v3.contentType - 0;
                      threeObj.level = 3;
                      itemObj.children.push(threeObj);
                    } else {
                      // 如果有children 自己 是二级
                      let secondObj = {};
                      secondObj.id = v3.id;
                      secondObj.title = v3.content;
                      secondObj.level = 2;
                      secondObj.children = [];
                      v3.children.forEach((v4) => {
                        let threeObj = {};
                        threeObj.id = v4.id;
                        threeObj.title = v4.content;
                        threeObj.desc = v4.contentValue;
                        threeObj.descType = v4.contentType - 0;
                        threeObj.level = 3;
                        secondObj.children.push(threeObj);
                      });
                      itemObj.children.push(secondObj);
                    }
                  });
                }
                innerArr.push(itemObj);
              });
              outerArr.push(innerArr);
            });
            this.hospitalPackageList = outerArr;
            console.log(outerArr, "final..");
          } else if (this.tabIndex === 1) {
            this.areaPackage = res.data.map((v) => {
              return {
                id: v.id,
                packageTitle: v.packageName,
                packageSubTitle: v.valueDescribe,
                packageDesc: v.applicableObjects,
                price: v.price,
                priceDesc: v.priceUnitName,
                applyReportFileId: v.applyReportFileId,
                applyReportFileName: v.applyReportFileName,
                signContractFileId: v.signContractFileId,
                signContractFileName: v.signContractFileName,
                priceSettingType: v.priceSettingType,
                lowestPrice: v.lowestPrice,
                highestPrice: v.highestPrice,
              };
            });
            if (this.isPreview == 1) {
              // 后台预览跳转
              this.areaPackage.forEach((v, i) => {
                if (this.serveId == v.id) {
                  this.$refs["areaSwipe"].swipeTo(i);
                }
              });
            }
            // 服务包详情列表
            let outerArr = [];
            res.data.forEach((v1) => {
              let innerArr = [];
              v1.serviceContents.forEach((v2) => {
                // 一级
                let itemObj = {};
                itemObj.id = v2.id;
                itemObj.title = v2.content;
                itemObj.level = 1;
                itemObj.children = [];
                if (v2.children) {
                  v2.children.forEach((v3) => {
                    // 如果没有children 自己 就是三级
                    if (!v3.children) {
                      let threeObj = {};
                      threeObj.id = v3.id;
                      threeObj.title = v3.content;
                      threeObj.desc = v3.contentValue;
                      threeObj.descType = v3.contentType - 0;
                      threeObj.level = 3;
                      itemObj.children.push(threeObj);
                    } else {
                      // 如果有children 自己 是二级
                      let secondObj = {};
                      secondObj.id = v3.id;
                      secondObj.title = v3.content;
                      secondObj.level = 2;
                      secondObj.children = [];
                      v3.children.forEach((v4) => {
                        let threeObj = {};
                        threeObj.id = v4.id;
                        threeObj.title = v4.content;
                        threeObj.desc = v4.contentValue;
                        threeObj.descType = v4.contentType - 0;
                        threeObj.level = 3;
                        secondObj.children.push(threeObj);
                      });
                      itemObj.children.push(secondObj);
                    }
                  });
                }
                innerArr.push(itemObj);
              });
              outerArr.push(innerArr);
            });
            this.areaPackageList = outerArr;
            console.log(outerArr, "final..");
          }
        }
        console.log(res);
      });
    },
    // 处理数据
    handeTreeData() {},
    // 去申请购买页
    goApplyUse(type, item) {
      this.cnzzStat('服务清单及报价', '服务清单及报价页面点击立即购买按钮','立即购买(SE_Key_Buying)');
      this.$router.push({
        path: "/applyUse",
        query: {
          type: type,
          id: item.id,
          buyType: "buy",
        },
      });
    },
    // 获取服务包列表
    getPackageList() {
      const params = {
        state: "1",
        delFlag: "N",
        packageType: "1",
      };
      // if(this._packageType) {
      //   params.packageType = this._packageType
      // }
      this.$http.getPackagesWhenApply(params).then((res) => {
        if (res.status === 200 && res.data && res.data.length > 0) {
          this.getPackageDetailById(res.data[0].id);
        }
        console.log(res);
      });
    },
    // 根据id获取服务包详情
    getPackageDetailById(id) {
      this.$http.getPackageDetailById(id).then((res) => {
        console.log(res, "11111");
      });
    },
    // 轮播图上一张
    preSwipe() {
      //    console.log('上一张...');
      // 院内
      if (this.tabIndex === 0) {
        this.$refs["hospitalSwipe"].prev();
      } else if (this.tabIndex === 1) {
        this.$refs["areaSwipe"].prev();
      }
    },
    // 轮播图下一张
    nextSwipe() {
      //    console.log('上一张...');
      // 院内
      if (this.tabIndex === 0) {
        this.$refs["hospitalSwipe"].next();
      } else if (this.tabIndex === 1) {
        this.$refs["areaSwipe"].next();
      }
    },
    // 选择了电话
    phoneSelect(e) {
      this.callPhone(e.name);
      console.log(e);
    },
    // 院内服务包吸顶滚动
    hospitalPackageScroll(e) {
      if (this.tabIndex === 0) {
        if (e.isFixed && !this.hospitalStickContainerShow) {
          this.hospitalStickContainerShow = true;
        }
        if (!e.isFixed && this.hospitalStickContainerShow) {
          this.hospitalStickContainerShow = false;
        }
      } else if (this.tabIndex === 1) {
        // console.log(e,'变....');
        if (e.isFixed && !this.areaStickContainerShow) {
          this.areaStickContainerShow = true;
        }
        if (!e.isFixed && this.areaStickContainerShow) {
          this.areaStickContainerShow = false;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#serviceList {
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #666666;
  line-height: 20px;
  // min-height: 3000px;
  .banner {
    height: 140px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .swipe_wrap {
    height: 405px;
    box-sizing: border-box;
    padding: 30px 0 0 0;
    // padding-top: 30px;
    // background: yellow;
    .swipe_center {
      // margin-top: 30px;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 0 12px;
      height: 320px;
      img {
        width: 16px;
        height: 16px;
      }
      .my-swipe {
        overflow: hidden;
        width: 285px;
        height: 316px;
        opacity: 1;
        background: #ffffff;
        // background: pink;
        border-radius: 10px;
        box-shadow: 0px 0px 8px 0px rgba(81, 116, 143, 0.16);
        .swipe_item {
          position: relative;
          .header {
            width: 285px;
            height: 123px;
            background: url("../../assets/images/serviceList/bg-swipe-mask.png");
            background-size: 100% 100%;
            .package_title {
              // margin-top: 15px;
              box-sizing: border-box;
              padding-top: 15px;
              font-size: 24px;
              font-family: PingFangSC, PingFangSC-Medium;
              font-weight: 500;
              text-align: center;
              color: #ffffff;
              line-height: 33px;
            }
            font-size: 15px;
            text-align: center;
            color: #ffffff;
            line-height: 21px;
            .package_sub_title {
              margin-top: 9px;
            }
            .package_desc {
              margin-top: 9px;
            }
          }
          .body {
            box-sizing: border-box;
            padding-top: 36px;
            // position: relative;
            // height: 100%;
            .package_price {
              font-size: 32px;
              font-family: PingFangSC, PingFangSC-Medium;
              font-weight: 500;
              text-align: center;
              color: #333333;
              line-height: 45px;
              span {
                margin-left: 5px;
                font-size: 16px;
                color: #333333;
                line-height: 22px;
              }
            }
            .buy_btn {
              position: absolute;
              bottom: 30px;
              // margin: 32px auto 0;
              left: 50%;
              transform: translateX(-50%);
              width: 241px;
              height: 50px;
              opacity: 1;
              background: linear-gradient(143deg, #4fc2ff 9%, #1c91ff 100%);
              border-radius: 4px;
              font-size: 18px;
              color: #ffffff;
              line-height: 25px;
            }
          }
        }
      }
    }
    .swipe_indicator {
      margin-top: 43px;
      .swipe_indicator_item {
        margin-right: 13px;
        flex-shrink: 0;
        width: 10px;
        height: 10px;
        opacity: 1;
        background: #eeeeee;
        border-radius: 50%;
      }
      .active {
        background: #1c91ff;
      }
    }
  }
  .package_detail {
    padding-top: 40px;
    position: relative;
    background: #ffffff;
    .package_stick_panel {
      position: absolute;
      height: 60px;
      top: 0;
      left: 0;
      right: 0;
      background: #f5f9ff;
      box-sizing: border-box;
      // padding: 0 17px;
      z-index: -99;
      .stick_swrap {
        box-sizing: border-box;
        padding: 0 12px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 60px;
        background: #f5f9ff;
      }
      img {
        width: 16px;
        height: 16px;
      }
      .package_title {
        margin-bottom: 12px;
        font-size: 16px;
        color: #333333;
        text-align: center;
        line-height: 22px;
      }
      .dot_list {
        .dot {
          margin-right: 13px;
          width: 10px;
          height: 10px;
          opacity: 1;
          background: #eeeeee;
          border-radius: 50%;
        }
        .active {
          background: #1c91ff;
        }
      }
    }
    .package_stick_panel_show {
      z-index: 99;
    }
    .detail_package_name {
      margin-bottom: 17px;
      font-size: 18px;
      font-family: SourceHanSansCN, SourceHanSansCN-Bold;
      font-weight: 700;
      text-align: center;
      color: #333333;
      line-height: 24px;
    }
    .detail_package_name_hide {
      color: #ffffff;
    }
    .detail_package_content {
      box-sizing: border-box;
      padding: 0 12px;
      .package_table {
        border: 1px solid #ddd;
        position: relative;
        border-radius: 6px;
        //  min-height: 200px;
        max-height: 620px;
        overflow: hidden;
        //  background: pink;
        .tr {
          border-bottom: 1px solid #ddd;
          display: flex;
          font-size: 15px;
          font-family: SourceHanSansCN, SourceHanSansCN-Medium;
          font-weight: 500;
          text-align: left;
          color: #333333;
          line-height: 22px;
          .td {
            min-height: 50px;
            display: flex;
            font-size: 14px;
            font-weight: 400;
            align-items: center;
            font-family: SourceHanSansCN, SourceHanSansCN-Regular;
            color: #333333;
          }
          .td_left {
            flex-shrink: 0;
            width: 222px;
            border-right: 1px solid #ddd;
            box-sizing: border-box;
            padding: 5px 9px 5px 15px;
          }
          .td_right {
            width: 100%;
            box-sizing: border-box;
            padding: 5px 10px;
            text-align: center;
            .i_right {
              width: 16px;
              height: 16px;
            }
            .i_error {
              width: 16px;
              height: 16px;
            }
          }
        }
        .tr:last-child {
          border-bottom-width: 0px;
        }
        .tr_1 {
          box-sizing: border-box;
          //  padding-left: 15px;
          background: #f5f9ff;
          .td {
            font-size: 15px;
            box-sizing: border-box;
            font-weight: 500;
            padding: 14px 9px 14px 15px;
          }
        }
        .tr_2 {
          .td {
            font-size: 15px;
            box-sizing: border-box;
            font-weight: 500;
            padding: 14px 9px 14px 15px;
          }
          box-sizing: border-box;
          // padding-left: 15px;
          background: #fffaf5;
        }
        .package_mask {
          position: absolute;
          bottom: 0;
          width: 100%;
          height: 93px;
          background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.09),
            rgba(28, 145, 255, 0.1)
          );
        }
      }
      .package_table_more {
        max-height: 9999px;
      }
    }
    .detail_package_footer {
      margin-top: 13px;
      margin-bottom: 30px;
      color: #1c91ff;
      img {
        margin-left: 11px;
        width: 16px;
        height: 16px;
      }
    }
  }
  .footer_holder {
    height: 60px;
  }
  // .tr_border {
  //   border-bottom: 1px solid #ddd;
  // }
  .tr {
    border-bottom: 1px solid #ddd !important;
  }
  .outer {
    // position: relative;
    .other_qr {
      // position: absolute;
      // top: 0;
      // left: 0;
      // opacity: 0;
    }
  }
}
</style>